<template>
  <div>
    <custom-sidebar
      :title="title"
      :title-icon="titleIcon"
      v-model="model"
      @close="close"
      :width="isMobile ? '100%' : '580px'"
    >
      <div v-if="isAppointmentInfo">
        <div
          class="d-flex justify-content-between align-items-center bg-gray-light p-3 rounded shadow-sm title-container"
        >
          <div
            class="d-flex justify-content-between align-items-center pointer py-2"
            @click="collapseValue = !collapseValue"
          >
            <div
              class="custom-collapse-header-icon mr-1 rounded-circle shadow-sm text-center"
              :class="{
                'bg-orange': collapseValue,
                'bg-dark-gray': !collapseValue,
              }"
            >
              <span
                class="text-white"
                :class="{
                  'fal fa-minus': collapseValue,
                  'fal fa-plus': !collapseValue,
                }"
              ></span>
            </div>
            <span>
              Ver Información de la Cita
            </span>
          </div>
          <div v-if="canEdit">
            <action-button
              variant="success btn-sm"
              type="button"
              i="fas fa-edit"
              @click="toggleEdit"
            ></action-button>
          </div>
        </div>
        <b-collapse v-model="collapseValue">
          <div class="p-3">
            <div class="row my-3">
              <div class="col-md-6 col-12 mb-2">
                <div class="d-flex">
                  <i class="fas fa-user text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Estudiante:
                    </div>
                    {{ appointment.student?.name | empty }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="d-flex">
                  <i class="fas fa-file-user text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Número de SIE:
                    </div>
                    {{ appointment.student?.sie | empty }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-6 col-12 mb-2">
                <div class="d-flex">
                  <i class="fas fa-file-alt text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Estatus:
                    </div>

                    <div class="d-flex align-items-center">
                      <div
                        class="dot rounded-circle mr-2"
                        :style="{ backgroundColor: appointment.status?.color }"
                      ></div>
                      {{ appointment.status?.name | empty }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="d-flex">
                  <i class="fas fa-file-user text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Número de Referido:
                    </div>
                    {{ appointment.referralNumber | empty }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-6 col-12 mb-2">
                <div class="d-flex">
                  <i class="fas fa-calendar-alt text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Fecha:
                    </div>
                    {{ appointment.dates?.from | date }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="d-flex">
                  <i class="fas fa-location-dot text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      CAAT:
                    </div>
                    {{ appointment.caat }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-6 col-12 mb-2">
                <div class="d-flex">
                  <i class="fas fa-clock text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Desde:
                    </div>
                    {{ appointment.dates?.from | hour }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="d-flex">
                  <i class="fas fa-clock text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Hasta:
                    </div>
                    {{ appointment.dates?.to | hour }}
                  </div>
                </div>
              </div>
            </div>
            <div class="my-4">
              <section-title content="Participantes" has-line />
              <div v-if="hasParticipants">
                <div
                  class="bg-light-gray rounded my-3"
                  v-for="(participant, key) in appointment.participants"
                  :key="key"
                >
                  <div class="p-3">
                    <p class="font-weight-bold mb-2">
                      {{ participant.name | empty }}
                    </p>
                    <div v-if="participant.position">
                      {{ participant.position }} /
                    </div>
                    <div v-if="participant.department">
                      {{ participant.department }}
                    </div>
                  </div>
                </div>
              </div>
              <custom-result-not-found
                v-else
                text="No hay participantes asociados a la cita"
              />
            </div>
          </div>
        </b-collapse>

        <div v-if="isEditing" class="mt-4">
          <div>
            <label for="reasonOfChange" class="data-label">
              Razón de Cambio de Cita:
            </label>
            <div class="w-100">
              <button
                type="button"
                class="btn border col-12"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div class="d-flex justify-content-between">
                  <span>{{ formModel.reasonOfChange.name }}</span>
                  <div><i class="fas fa-chevron-down"></i></div>
                </div>
              </button>
              <div class="dropdown-menu mt-2 w-90">
                <a
                  class="dropdown-item pointer"
                  v-for="(item, key) in options"
                  :key="key"
                  @click="() => handlerChangeReasonOfChange(item)"
                >
                  {{ item.name }}
                </a>
              </div>
            </div>
          </div>
          <validation-observer ref="form">
            <div class="mt-4">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-text-area
                  id="txtComment"
                  :maxlength="3000"
                  placeholder="Escribe un comentario"
                  label="Comentario:"
                  v-model="formModel.comments"
                  :error="errors[0]"
                  :custom-error-msg="'Este campo es requerido'"
                />
              </validation-provider>
            </div>
            <div v-if="isChangeSchedule">
              <div v-if="isChangeDate" class="mt-4">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-date-picker
                    required
                    v-model="formModel.date"
                    label="Fecha:"
                    placeholder="DD/MM/YYYY"
                    class="custom-datetime-picker-container"
                    :container-class="'w-100'"
                    :error="errors[0]"
                    :custom-error-msg="'La fecha es requerida'"
                    :disabled-days="definedTime?.disabledDays.split(',')"
                  />
                </validation-provider>
              </div>
              <div class="mt-4">
                <div class="row">
                  <div class="col-12 col-lg-6 mb-4 mb-lg-0">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-time-picker
                        label="Desde:"
                        v-model="formModel.fromHour"
                        :error="errors[0]"
                        :custom-error-msg="'La hora de inicio es requerida'"
                        ref="fromHour"
                      />
                    </validation-provider>
                  </div>
                  <div class="col-12 col-lg-6">
                    <validation-provider
                      v-slot="{ errors, failedRules }"
                      :rules="`required|timeGreaterThan:${formModel.fromHour}`"
                    >
                      <custom-time-picker
                        label="Hasta:"
                        v-model="formModel.toHour"
                        :error="errors[0]"
                        :custom-error-msg="
                          failedRules['timeGreaterThan']
                            ? 'La hora de fin debe ser mayor que la hora de inicio.'
                            : 'La hora de fin es requerida.'
                        "
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isAddParticipant">
              <div class="row ">
                <div class="col-12 mt-3">
                  <custom-auto-complete
                    v-model="participant"
                    label="Participante(s):"
                    ref="autocompleteRef"
                    placeholder="Escriba Nombre del Participante"
                    v-on="$listeners"
                    :debounce-time="2000"
                    :get-result-value="getResultValue"
                    :search="searchAutoCompleteHandler"
                    :class="'w-100'"
                    @changed="handleOnChange"
                    @submit="handleSubmit"
                  />
                </div>
                <div class="col-12 mt-3">
                  <custom-drop-down
                    label="CAAT:"
                    fieldkey="id"
                    fieldname="name"
                    :disabled="specialistsCaatsFiltered.length <= 1"
                    :options="specialistsCaatsFiltered"
                    placeholder="Seleccione"
                    v-model="caat"
                  />
                </div>
                <div class="col mt-3 text-right">
                  <action-button
                    variant="success"
                    :i="`fas fa-file-plus pr-1`"
                    :disabled="caat == null"
                    @click="addParticipantToList"
                  >
                    Añadir Participante
                  </action-button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <icon-view
                    class="mt-4"
                    :has-border="false"
                    icon="fas fa-user-circle text-orange"
                    icon-size="17px"
                    variant="custom-icon-view"
                    icon-background="white"
                    title="Participantes"
                  />
                </div>
              </div>
              <div class="row p-2 pt-0">
                <div
                  v-for="(participant, key) in appointment.participants"
                  class="bg-light-gray p-3 col-12 mt-2"
                  :key="'old-' + key"
                >
                  <div class="text-right" v-if="participant.fromCalendarFlag">
                    <span
                      @click="
                        removeParticipantFromList(participant.userId, true)
                      "
                      class="cursor-pointer"
                    >
                      x
                    </span>
                  </div>
                  <strong>{{ participant.name }}</strong>
                  <p class="mt-2">
                    {{ participant.position }} / {{ participant.department }}
                  </p>
                </div>
                <div
                  v-for="(participant, index) in selectedParticipantsList"
                  class="bg-light-gray p-3 mt-2 col-12"
                  :key="index"
                >
                  <div class="text-right">
                    <span
                      @click="removeParticipantFromList(participant.userId)"
                      class="cursor-pointer"
                    >
                      x
                    </span>
                  </div>
                  <strong>{{ participant.fullName }}</strong>
                  <p class="mt-2">
                    {{ participant.roleName }} / {{ participant.companyName }}
                  </p>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
        <div v-else-if="isNotifyingAbsence" class="mt-4">
          <validation-observer ref="notifyAbsenceForm">
            <div class="d-flex flex-column">
              <div>
                <div class="color-secondary-6 font-14">
                  Razón:
                </div>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccione"
                    v-model="notifyAbsence.model.reason"
                    :options="notifyAbsence.reasons"
                    :error="errors[0]"
                    custom-error-msg="La razón es requerida"
                  />
                </validation-provider>
              </div>
              <div class="mt-3">
                <div class="color-secondary-6 font-14">
                  Comentario:
                </div>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-text-area
                    id="txtComment"
                    :maxlength="3000"
                    placeholder="Escribe un comentario"
                    v-model="notifyAbsence.model.comment"
                    :error="errors[0]"
                    custom-error-msg="El comentario es requerido"
                  />
                </validation-provider>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
      <div v-else-if="isAppointmentHistory">
        <appointment-history
          :referral-number="appointment.referralNumber"
          :items="appointmentLog"
        />
      </div>
      <template #footer>
        <div
          v-if="isAppointmentInfo"
          class="d-flex justify-content-center align-items-center gap-x-2"
        >
          <div class="w-50" v-if="isEditingOrAbsence">
            <action-button
              v-if="isEditing || isNotifyingAbsence"
              :variant="
                isMobile
                  ? 'outline-danger w-100 mb-2'
                  : 'outline-danger w-100 px-5 fs-15'
              "
              type="button"
              i="fas fa-times-circle"
              @click="cancel"
            >
              Cancelar
            </action-button>
            <action-button
              v-else-if="isAppointmentCoordinate"
              :variant="isMobile ? 'success w-100 mb-2' : 'success px-5 w-100'"
              type="button"
              i="fas fa-user-xmark"
              @click="notifyAbsenceHandler"
            >
              Notificar Ausencia
            </action-button>
          </div>
          <div :class="isEditingOrAbsence ? 'w-50' : 'w-100'">
            <action-button
              v-if="isEditing || isNotifyingAbsence"
              :variant="isMobile ? 'success' : 'success  px-5 w-100'"
              type="button"
              i="fas fa-save"
              @click="save"
            >
              Guardar
            </action-button>
            <action-button
              v-else
              :variant="
                isMobile
                  ? 'outline-success w-100 mb-2'
                  : 'outline-success px-5 w-100'
              "
              type="button"
              i="fas fa-clock-rotate-left"
              @click="seeHistory"
            >
              Ver Historial de Cita
            </action-button>
          </div>
        </div>
        <div v-else-if="isAppointmentHistory">
          <action-button
            variant="outline-success"
            type="button"
            style="width:100% !important"
            i="fa fa-arrow-circle-left"
            @click="backFromAppointmentHistory"
          >
            Regresar
          </action-button>
        </div>
      </template>
    </custom-sidebar>
  </div>
</template>
<script>
const views = Object.freeze({ APPOINTMENTINFO: 1, APPOINTMENTHISTORY: 2 });

import ActionButton from 'ActionButton';
import SectionTitle from 'SectionTitle';
import CustomResultNotFound from 'custom-result-not-found';
import CustomTextArea from '@quisit/custom-text-area';
import CustomDatePicker from '@/components/common/form/CustomDatePicker.vue';
import CustomSidebar from '@/components/common/CustomSidebar.vue';
import CustomTimePicker from '@/components/common/CustomTimePicker.vue';
import appointmentcalendarService from '@/services/api/appointmentcalendar.api';
import appointmentChangeReasons from '@/utils/constants/appointmentChangeReasons';
import mixAlert from '@/mixins/alert.mixin';
import appointmentStatus from '@/utils/constants/appointmentStatus';
import IconView from 'icon-view';
import { CustomAutoComplete } from '@/components/common';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import CustomDropDown from 'custom-drop-down';
import appointmentChangeReason from '@/utils/constants/appointmentChangeReason';
import AppointmentHistory from './AppointmentHistory.vue';
import referralService from '@/services/api/referralsandequipments.api';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
export default {
  name: 'CalendarSidebar',
  components: {
    ActionButton,
    SectionTitle,
    CustomResultNotFound,
    CustomSidebar,
    CustomTextArea,
    CustomDatePicker,
    CustomTimePicker,
    IconView,
    CustomAutoComplete,
    CustomDropDown,
    AppointmentHistory,
  },
  mixins: [mixAlert],
  props: {
    appointment: {
      type: Object,
      required: true,
    },
    definedTime: {
      type: Object,
      default: () => null,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    selectedView: views.APPOINTMENTINFO,
    appointmentLog: [],
    collapseValue: true,
    isEditing: false,
    formModel: {
      reasonOfChange: {
        id: null,
        name: 'Seleccione',
      },
      comments: '',
      date: null,
      fromHour: null,
      toHour: null,
    },
    options: [],
    caat: null,
    participant: null,
    searchParticipantSnapshot: {
      data: [],
    },
    specialistsFiltered: [],
    specialistsCaatsFiltered: [],
    selectedParticipantsList: [],
    participantsToRemove: [],
    notifyAbsence: {
      active: false,
      model: { reason: null, comment: null },
      reasons: [],
    },
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isEditingOrAbsence() {
      return (
        this.isEditing ||
        this.isNotifyingAbsence ||
        this.isAppointmentCoordinate
      );
    },
    canEdit() {
      return (
        this.userHasPermissions(
          'technologyassistance.calendarappointment.edit'
        ) && this.isAppointmentCoordinate
      );
    },
    hasParticipants() {
      return this.appointment.participants?.length > 0;
    },
    title() {
      if (this.isEditing) return 'Editar Cita';
      if (this.isNotifyingAbsence) return 'Notifica Ausencia';
      if (this.isAppointmentHistory) return 'Historial de Citas';
      return 'Información de Cita';
    },
    titleIcon() {
      if (this.isEditing) return 'fas fa-edit fa-xs';
      if (this.isNotifyingAbsence) return 'fas fa-user-xmark fa-xs';
      if (this.isAppointmentHistory) return 'fas fa-clock-rotate-left';
      return 'fas fa-info-circle';
    },
    isChangeSchedule() {
      return (
        this.formModel.reasonOfChange.id ===
          appointmentChangeReasons.ScheduleChange ||
        this.formModel.reasonOfChange.id === appointmentChangeReasons.DateChange
      );
    },
    isAddParticipant() {
      return (
        this.formModel.reasonOfChange.id ===
        appointmentChangeReasons.ChangeParticipant
      );
    },
    isChangeDate() {
      return (
        this.formModel.reasonOfChange.id === appointmentChangeReasons.DateChange
      );
    },
    isAppointmentCoordinate() {
      return this.appointment.status?.id === appointmentStatus.Coordinate;
    },
    isNotifyingAbsence() {
      return this.notifyAbsence.active;
    },
    isAppointmentInfo() {
      return this.selectedView == views.APPOINTMENTINFO;
    },
    isAppointmentHistory() {
      return this.selectedView == views.APPOINTMENTHISTORY;
    },
  },
  async mounted() {
    await Promise.all([
      this.getAppointmentChangeReasons(),
      this.getAppointmentAbsenceReasons(),
    ]);
  },
  methods: {
    async getAppointmentLog() {
      const { data } = await referralService.getAppointmentLog(
        this.appointment.peiAtServiceId
      );
      this.appointmentLog = data;
    },
    close() {
      this.selectedView = views.APPOINTMENTINFO;
      this.isEditing = false;
      this.notifyAbsence.active = false;
      this.clear();
      this.$emit('close');
    },
    notifyAbsenceHandler() {
      this.notifyAbsence.model = { reason: null, comment: null };
      this.collapseValue = false;
      this.notifyAbsence.active = true;
    },
    async seeHistory() {
      await this.getAppointmentLog();
      this.selectedView = views.APPOINTMENTHISTORY;
      this.$emit('see-history');
    },
    toggleEdit() {
      this.isEditing = !this.isEditing;
      if (this.isEditing) {
        this.collapseValue = false;
      } else {
        this.clear();
      }
    },
    cancel() {
      if (this.isEditing) this.toggleEdit();
      if (this.isNotifyingAbsence) this.cancelNotifyAbsence();
    },
    async save() {
      if (this.isEditing) await this.handlerEditEvent();
      if (this.isNotifyingAbsence) await this.saveNotifyAbsence();
    },
    cancelNotifyAbsence() {
      this.notifyAbsence.active = false;
      this.notifyAbsence.model = { reason: null, comment: null };
    },
    clear() {
      this.formModel.reasonOfChange = {
        id: null,
        name: 'Seleccione',
      };
      this.formModel.comments = '';
      this.formModel.date = null;
      this.formModel.fromHour = null;
      this.formModel.toHour = null;
      this.isEditing = false;
      this.selectedParticipantsList = [];
      this.participantsToRemove = [];
      this.participant = null;
    },
    handlerChangeReasonOfChange(value) {
      this.formModel.reasonOfChange = value;
    },
    async handlerEditEvent() {
      if (
        this.formModel.reasonOfChange.id ==
        appointmentChangeReason.AddParticipant
      ) {
        await this.handlerSaveAddParticipantEvent();
        return;
      }
      await this.handlerEditAppointmentEvent();
    },
    async handlerEditAppointmentEvent() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        return;
      }
      const payload = {
        appointmentId: this.appointment.id,
        reasonId: this.formModel.reasonOfChange.id,
        date: this.formModel.date || this.appointment.dates.from,
        timeFrom: this.formModel.fromHour,
        timeTo: this.formModel.toHour,
        comment: this.formModel.comments,
      };

      try {
        const { data } = await appointmentcalendarService.changeAppointment(
          payload
        );

        this.$emit('edit-event', data);
        this.model = false;
        this.close();
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido editando la cita, por favor intente de nuevo.',
          'error'
        );
      }
    },
    async getAppointmentChangeReasons() {
      const {
        data,
      } = await appointmentcalendarService.getAppointmentChangeReasons();
      this.options = data;
    },
    async getAppointmentAbsenceReasons() {
      const {
        data,
      } = await referralAndEquipmentsservice.getAbsenceStatusReasons();
      this.notifyAbsence.reasons = data;
    },
    addParticipantToList() {
      if (
        this.selectedParticipantsList.some(
          (x) =>
            (this.searchParticipantSnapshot.specialistId &&
              x.specialistId == this.searchParticipantSnapshot.specialistId) ||
            (this.searchParticipantSnapshot.userId &&
              x.userId == this.searchParticipantSnapshot.userId)
        ) ||
        this.appointment.participants.some(
          (x) =>
            (this.searchParticipantSnapshot.specialistId &&
              x.specialistId == this.searchParticipantSnapshot.specialistId) ||
            (this.searchParticipantSnapshot.userId &&
              x.userId == this.searchParticipantSnapshot.userId)
        )
      ) {
        this.ShowToast(
          'Alerta',
          'El participante ya se encuentra en la lista.',
          'error'
        );
        this.clearSearchModel();
        return false;
      }
      this.selectedParticipantsList.push({
        specialistId: this.searchParticipantSnapshot.specialistId,
        userId: this.searchParticipantSnapshot.userId,
        roleId: this.searchParticipantSnapshot.roleId,
        companyId: this.searchParticipantSnapshot.companyId,
        companyName: this.searchParticipantSnapshot.companyName,
        fullName: this.searchParticipantSnapshot.input,
        roleName: this.searchParticipantSnapshot.roleName,
        caatId: this.caat.id,
        specialistLocationId: this.caat.specialistLocationId,
        isATEvaluator: this.searchParticipantSnapshot.isATEvaluator,
      });
      this.clearSearchModel();
    },
    removeParticipantFromList(userId, isOld = false) {
      if (isOld) {
        const participant = this.appointment.participants.find(
          (x) => x.userId === userId
        );

        this.participantsToRemove.push(participant.id);

        this.appointment.participants = this.appointment.participants.filter(
          (x) => x.userId != userId
        );
        return;
      }

      this.selectedParticipantsList = this.selectedParticipantsList.filter(
        (x) => x.userId != userId
      );
    },
    getResultValue(result) {
      return result.fullName;
    },
    searchAutoCompleteHandler(input) {
      return new Promise((resolve) => {
        if (input.length < 4) {
          return resolve([]);
        }

        if (input == this.searchParticipantSnapshot.input) {
          return resolve(this.searchParticipantSnapshot.data);
        }
        this.searchParticipantSnapshot.input = input;
        referralAndEquipmentsservice
          .getAllParticipants(input)
          .then(({ data: response }) => {
            this.specialistsFiltered = [];
            this.searchResponse = response;

            response.forEach((element) => {
              const especialistExists = this.specialistsFiltered.some(
                (x) =>
                  x.userId == element.userId &&
                  x.specialistId == element.specialistId &&
                  x.roleId == element.roleId
              );
              if (!especialistExists) {
                this.specialistsFiltered.push({
                  fullName: element.fullName,
                  userId: element.userId,
                  specialistId: element.specialistId,
                  roleName: element.roleName,
                  companyName: element.companyName,
                  companyId: element.companyId,
                  roleId: element.roleId,
                  isATEvaluator: element.isATEvaluator,
                });
              }
            });

            this.searchParticipantSnapshot.data = this.specialistsFiltered.map(
              (item) => ({
                ...item,
                fullName: item.fullName,
                sub1: item.roleName,
                sub2: item.companyName,
              })
            );
            resolve(this.searchParticipantSnapshot.data);
          });
      });
    },
    async saveNotifyAbsence() {
      const valid = await this.$refs.notifyAbsenceForm.validate();
      if (!valid) return;
      try {
        const payload = {
          appointmentId: this.appointment.id,
          peiAtServiceId: this.appointment.peiAtServiceId,
          reasonId: this.notifyAbsence.model.reason.id,
          comment: this.notifyAbsence.model.comment,
          participants: this.appointment.participants.map((x) => ({
            caatId: x.caatId,
            participantId: x.id,
          })),
        };
        await referralAndEquipmentsservice.saveAppointmentAbsence(payload);

        this.cancelNotifyAbsence();
        this.model = false;
        this.$emit('close');
        this.ShowToast(
          'Éxito',
          'Se ha guardado la ausencia correctamente',
          'success'
        );
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un error al notifica ausencia, por favor intente de nuevo.',
          'error'
        );
      }
    },
    async handleSubmit(val) {
      this.participant = val.fullName;
      this.searchParticipantSnapshot.input = val.fullName;
      this.searchParticipantSnapshot.specialistId = val.specialistId;
      this.searchParticipantSnapshot.userId = val.userId;
      this.searchParticipantSnapshot.companyId = val.companyId;
      this.searchParticipantSnapshot.companyName = val.companyName;
      this.searchParticipantSnapshot.roleName = val.roleName;
      this.searchParticipantSnapshot.roleId = val.roleId;
      this.searchParticipantSnapshot.isATEvaluator = val.isATEvaluator;

      this.specialistsCaatsFiltered = [];
      const caats = this.searchResponse.filter(
        (x) =>
          x.userId == val.userId &&
          x.specialistId == val.specialistId &&
          x.roleId == val.roleId
      );
      caats.forEach((caat) => {
        this.specialistsCaatsFiltered.push({
          id: caat.caatId,
          name: caat.caatName,
          specialistLocationId: caat.specialistLocationId,
        });
      });
      if (this.specialistsCaatsFiltered.length == 1) {
        this.caat = this.specialistsCaatsFiltered[0];
      }
    },
    handleOnChange(val) {
      this.participant = val.fullName;
      if (!val) {
        this.searchParticipantSnapshot.input = null;
      }
    },
    clearSearchModel() {
      this.searchParticipantSnapshot = {
        data: [],
      };
      this.specialistsCaatsFiltered = [];
      this.specialistsFiltered = [];
      this.caat = null;
      this.$refs.autocompleteRef.onClearHandler();
    },
    async handlerSaveAddParticipantEvent() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        return;
      }

      const payload = {
        appointmentId: this.appointment.id,
        reasonId: this.formModel.reasonOfChange.id,
        participants: this.selectedParticipantsList.map((item) => ({
          userId: item.userId,
          roleId: item.roleId,
          isATEvaluator: item.isATEvaluator,
          companyId: item.companyId,
          specialistLocationId: item.specialistLocationId,
          specialistId: item.specialistId,
          caatId: item.caatId,
        })),
        participantsToRemove: this.participantsToRemove,
        comment: this.formModel.comments,
      };

      try {
        const { data } = await appointmentcalendarService.updateParticipant(
          payload
        );
        this.toggleEdit();
        this.model = false;
        this.close();
        this.ShowToast(
          'Éxito',
          'Información ha sido guardada exitosamente.',
          'success'
        );
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un error añadiendo participante, por favor intente de nuevo.',
          'error'
        );
      }
    },
    backFromAppointmentHistory() {
      this.isEditing = false;
      this.selectedView = views.APPOINTMENTINFO;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
.custom-collapse-header-icon {
  width: 25px;
  height: 25px;
  border: solid 1px white;
}
.custom-collapse-header-icon + span {
  font-weight: 600;
}
.bg-gray-light {
  background-color: #efefef;
}
.pointer {
  cursor: pointer;
}

.custom-mt {
  margin-top: 5rem;
}

.btn-drowdown {
  min-height: 3rem;
}

::v-deep .width-container {
  width: 100% !important;
}

.btn-sm {
  height: 40px;
  width: 40px;
}

.title-container {
  height: 50px;
}

.dot {
  padding: 0.45rem;
}
.gap-x-2 {
  gap: 0px 20px;
}
.fs-15 {
  font-size: 15px;
}
</style>
